const CatgoryDetailStyle = {
  FontWeight: {
    medium: 500,
  },
};

export default CatgoryDetailStyle;
